import React from "react";
import { ArrowRight, Play } from "lucide-react";

const Hero = () => {
  return (
    <section id="top" className="relative">
      {/* Hero image */}
      <div className="relative w-full h-[46vh] min-h-[320px] sm:h-[62vh] overflow-hidden bg-[var(--ink)]">
        <img
          src="/assets/hero-mcdonogh.jpg"
          alt=""
          aria-hidden="true"
          className="hidden sm:block absolute inset-0 w-full h-full object-cover blur-2xl scale-110 opacity-70"
        />
        <img
          src="/assets/hero-mcdonogh.jpg"
          alt="McDonogh soccer players celebrating a goal"
          data-testid="hero-image"
          className="relative w-full h-full object-cover object-[center_30%] sm:object-contain animate-slow-zoom"
        />
        <span
          data-testid="hero-photo-credit"
          className="absolute bottom-3 right-4 z-10 text-[11px] font-medium text-white/85 drop-shadow"
        >
          Photo: A. Roberto
        </span>
        <div className="absolute inset-0 bg-gradient-to-t from-[var(--cream)] via-transparent to-transparent" />
      </div>

      {/* Editorial intro */}
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <div className="pt-12 sm:pt-16 pb-10 max-w-4xl">
          <div className="flex items-center gap-4 mb-8 animate-fade-up">
            <span className="h-[2px] w-10 bg-[var(--olive)]" />
            <span className="text-xs sm:text-sm font-bold tracking-eyebrow text-[var(--muted)] uppercase">
              National High School Sports Association
            </span>
          </div>

          <h1 className="animate-fade-up text-[13vw] leading-[0.94] sm:text-[80px] sm:leading-[0.9] font-extrabold tracking-tight text-[var(--ink)]">
            National rankings for the{" "}
            <span className="font-serif-display italic font-medium text-[var(--olive-2)]">
              high school game.
            </span>
          </h1>

          <p className="animate-fade-up mt-8 text-lg sm:text-xl leading-relaxed text-[var(--muted)] max-w-2xl">
            The NHSSA compiles national Top 20 rankings across football,
            basketball, soccer, volleyball, lacrosse and squash—boys and girls—
            and organizes championship tournaments. Established polls power some
            sports; the association ranks the rest, with every source and date shown.
          </p>

          <div className="animate-fade-up mt-9 flex flex-wrap items-center gap-4">
            <a
              href="#rankings"
              className="group inline-flex items-center gap-2 rounded-full bg-[var(--ink)] px-7 py-3.5 text-[15px] font-semibold text-[var(--cream)] transition-all hover:bg-[var(--ink-2)] hover:gap-3"
            >
              See this week's rankings
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
            </a>
            <a
              href="#model"
              className="inline-flex items-center gap-2 rounded-full border border-[var(--line)] bg-[var(--paper)] px-6 py-3.5 text-[15px] font-semibold text-[var(--ink)] transition-all hover:border-[var(--olive)]"
            >
              <Play className="w-4 h-4 text-[var(--olive-2)] fill-[var(--olive-2)]" />
              How the model works
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
